import React from "react";
import "./EssDashboard.css";
import { FaSearch, FaBell, FaUser } from "react-icons/fa";

const WelcomeCard = ({ data }) => {
  const currentTime = new Date().toLocaleTimeString();
  // console.log(data.last_name, ".,.,.,.,.,.,.,.,.,");

  return (
    <div className="card welcome-card mb-4 shadow">
      <div className="card-body d-flex justify-content-between align-items-center">
        <div className="text-white">
          <h1 className="h4 fw-bold mb-1">{`Welcome back, ${data.first_name} ${data.last_name}!`}</h1>

          {/* <p className="mb-0 text-white-50 small">{currentTime}</p> */}
          <p className="mt-2 text-white-50 small">
            Have a productive day ahead!
          </p>
        </div>
      </div>
    </div>
  );
};

export default WelcomeCard;
